/**
 * Adds to the space-separated list of aria-describedby ids for an element.
 * Prevents duplicated ids.  Returns true if the id was added.
 *
 * @param forElement: the element which is described
 * @param id: The id of the descriptive element to append to the list.
 * @returns true if added
 */
const appendDescribedBy = (forElement: HTMLElement, id: string): boolean => {
  const describedBy = forElement.getAttribute('aria-describedby');
  if (!describedBy || (describedBy && describedBy.indexOf(id) < 0)) {
    // add to the beginning of the list
    forElement.setAttribute('aria-describedby', `${id} ${describedBy || ''}`.trim());
    return true;
  }
  return false;
};

export default appendDescribedBy;
